import React, { Fragment } from 'react';
import AccountsHeading from 'Components/Blueprint/UI/Accounts/Heading';
import AccountsTable from 'Components/Blueprint/UI/Accounts/Table';
import AccountsTableInner from 'Components/Blueprint/UI/Accounts/TableInner';
import ShadowBox from 'Components/UI/ShadowBox';
import EditButton from 'Components/Blueprint/UI/EditButton';
import Currency from 'Components/Format/Currency';
import Content from 'Components/Blueprint/UI/Content';
import PropTypes from 'prop-types';
import BlueprintBalanceForResources from 'Components/Blueprint/UI/BlueprintBalanceForResources';
import fr from 'facet-rest';
import { openURLInNewTab } from 'Helpers/Navigation';

const View = ({ collegeEducationAccounts }) => {
  return (
    <div className="investment-assets">
      {collegeEducationAccounts.length > 0 ? (
        <Fragment>
          <AccountsHeading
            title="Legacy Assets"
          >
            <AccountsTable className="accounts-legacy">
              <tr className="headings">
                <td className="additions">Additions</td>
                <td className="balance">Balance</td>
                <td className="institution">Institution</td>
                <td className="type">Type</td>
                <td className="owner">Owner</td>
                <td className="beneficiary">Beneficiary</td>
                <td className="type-of-plan">Type of Plan</td>
              </tr>
            </AccountsTable>
          </AccountsHeading>
          {/*
          |--------------------------------------------------------------------------
          | College Accounts
          |--------------------------------------------------------------------------
          */}
          {collegeEducationAccounts.length > 0 && (
            <Fragment>
              <AccountsTableInner>
                <ShadowBox>
                  <AccountsTable className="accounts-legacy">
                    {collegeEducationAccounts.map(account => (
                      <tr key={`${account.id()}cea`} className="data">
                        <td className="additions">
                          <EditButton
                            title="Edit Legacy Account"
                            onClick={() => {
                              account.withRelationship(
                                fr.relationships.edit.name,
                                (rel) => openURLInNewTab(rel.link('related').url()),
                                () => null,
                              );
                            }}
                          />
                          {account.attr('annualAdditions') !== null && (
                            <Currency
                              amount={account.attr('annualAdditions')}
                            />
                          )}
                        </td>
                        <BlueprintBalanceForResources account={account} />
                        <td className="institution">
                          {account.attr('institution')}
                        </td>
                        <td className="type">{account.attr('type')}</td>
                        <td className="owner">{account.attr('owner')}</td>
                        <td className="beneficiary">
                          {account.attr('dependent')?.attr('firstName')}
                          &nbsp;
                          {account.attr('dependent')?.attr('lastName')}
                        </td>
                      </tr>
                    ))}
                  </AccountsTable>
                </ShadowBox>
              </AccountsTableInner>
            </Fragment>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <AccountsHeading title="Legacy Assets" />
          <Content className="double-side-padding no-top-padding">
            <p>No legacy assets.</p>
          </Content>
        </Fragment>
      )}
    </div>
  );
};

View.propTypes = {
  collegeEducationAccounts: PropTypes.array,
};
View.defaultProps = {
  collegeEducationAccounts: [],
};

export default View;
